<!--
 * @Descripttion: 资源文件选择器
 * @version: 1.0
 * @Author: lybbn
 * @Date: 2024-08-07
 * program django-vue-lyadmin
 * email: 1042594286@qq.com
-->

<template>
	<div class="ly-file-select">
		<div class="ly-file-select__side" v-loading="menuLoading">
            <div style="margin-bottom:20px;">
                <el-button type="primary" icon="plus" @click="handleGroupAdd">新建分组</el-button>
            </div>
			<div class="ly-file-select__side-menu">
				<el-tree ref="group" class="menu" :data="menu" :node-key="treeProps.key" :props="treeProps" default-expand-all :expand-on-click-node="false" :current-node-key="menu.length>0?menu[0][treeProps.key]:''" highlight-current @node-click="groupClick">
					<template #default="{ node }">
						<span class="el-tree-node__label">
							<el-icon class="icon"><folder /></el-icon>{{node.label}}
						</span>
					</template>
				</el-tree>
			</div>
			<div class="ly-file-select__side-msg" v-if="multiple">
				已选择 <b>{{value.length}}</b> / <b>{{max}}</b> 项
			</div>
		</div>
		<div class="ly-file-select__files" v-loading="listLoading">
			<div class="ly-file-select__top">
				<div class="upload" v-if="!hideUpload">
					<el-upload class="ly-file-select__upload" action="" multiple :show-file-list="false" :accept="accept" :on-change="uploadChange" :before-upload="uploadBefore" :on-progress="uploadProcess" :on-success="uploadSuccess" :on-error="uploadError" :http-request="uploadRequest">
						<el-button type="primary" icon="Upload">本地上传</el-button>
					</el-upload>
					<span class="tips"><el-icon><warning /></el-icon>大小不超过{{maxSize}}MB</span>
				</div>
				<div class="keyword">
					<el-input v-model="keyword" prefix-icon="search" placeholder="文件名搜索" clearable @keyup.enter="search" @clear="search">
						<template #append>
							<el-button icon="Search" @click="search"/>
						</template>
					</el-input>
				</div>
			</div>
			<div class="ly-file-select__list">
				<el-scrollbar ref="scrollbar">
					<el-empty v-if="fileList.length==0 && data.length==0" description="无数据" :image-size="80"></el-empty>
					<div v-for="(file, index) in fileList" :key="index" class="ly-file-select__item">
						<div class="ly-file-select__item__file">
							<div class="ly-file-select__item__upload">
								<el-progress type="circle" :percentage="file.progress" :width="70"></el-progress>
							</div>
							<el-image :src="file.tempImg" fit="contain"></el-image>
						</div>
						<p>{{file.name}}</p>
					</div>
					<div v-for="item in data" :key="item[fileProps.key]" class="ly-file-select__item" :class="{active: value.includes(item[fileProps.url]) }" @click="select(item)">
						<div class="ly-file-select__item__file">
							<div class="ly-file-select__item__checkbox" v-if="multiple">
								<el-icon><check /></el-icon>
							</div>
							<div class="ly-file-select__item__select" v-else>
								<el-icon><check /></el-icon>
							</div>
							<div class="ly-file-select__item__box"></div>
							<el-image v-if="_isImg(item[fileProps.url])" :src="item[fileProps.url]" fit="contain" lazy></el-image>
						</div>
						<p :title="item[fileProps.fileName]">{{item[fileProps.fileName]}}</p>
					</div>
				</el-scrollbar>
			</div>
			<div class="ly-file-select__pagination">
				<el-pagination size="small" background layout="prev, pager, next" :total="total" :page-size="pageSize" v-model:currentPage="currentPage" @current-change="reload"></el-pagination>
			</div>
			<div class="ly-file-select__do">
				<slot name="custom_do"></slot>
				<el-button type="primary" :disabled="value.length<=0" @click="submit">确定</el-button>
			</div>
		</div>
		<LyDialog v-model="dialogVisible" :title="dialogTitle" width="380px" :before-close="handleClose" :showFullscreen="false">
			<el-form :inline="false" :model="formData" :rules="rules" ref="rulesForm" label-position="right" label-width="auto">
                <el-form-item label="分组名称：" prop="name">
                    <el-input v-model="formData.name"></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="handleClose" :loading="loadingSave">取消</el-button>
                <el-button type="primary" @click="submitData" :loading="loadingSave">确定</el-button>
            </template>
		</LyDialog>
	</div>
</template>

<script>
    import {systemFilegroup,systemFilegroupAdd,systemFiles,systemFilesAdd} from "@/api/api"
    import XEUtils from "xe-utils";
	import LyDialog from "@/components/dialog/dialog.vue";
	export default {
		props: {
			modelValue: null,
			hideUpload: { type: Boolean, default: false },
			multiple: { type: Boolean, default: false },
			max: {type: Number, default: 99},
			onlyImage: { type: Boolean, default: true },
			maxSize: {type: Number, default: 30},
		},
		components:{
			LyDialog
		},
		data() {
			return {
				formData:{
					name:""
				},
				dialogTitle:"",
				dialogVisible:false,
				loadingSave:false,
				keyword: null,
				pageSize: 20,
				total: 0,
				currentPage: 1,
				data: [],
				menu: [],
				menuId: '',
				value: this.multiple ? [] : '',
				fileList: [],
				accept: this.onlyImage ? "image/gif, image/jpeg, image/png" : "",
				listLoading: false,
				menuLoading: false,
				treeProps: {
                    key: 'id',
                    label: 'name',
                    children: 'children'
                },
				fileProps: {
                    key: 'id',
                    fileName: 'name',
                    url: 'url'
                },
				rules:{
                    name: [
                        {required: true, message: '请输入分组名称',trigger: 'blur'}
                    ]
                },
			}
		},
		watch: {
			multiple(){
				this.value = this.multiple ? [] : ''
				this.$emit('update:modelValue', JSON.parse(JSON.stringify(this.value)));
			}
		},
		mounted() {
			this.getMenu()
			this.getData()
		},
		methods: {
			handleGroupAdd(){
				this.dialogTitle = "新建分组"
                this.dialogVisible = true
			},
			handleClose(){
                this.dialogTitle =""
                this.dialogVisible = false
                this.loadingSave = false
                this.formData = {"name": ""}
            },
			submitData(){
				this.$refs['rulesForm'].validate(obj=>{
                    if(obj) {
                        this.loadingSave=true
                        let param = {
                            ...this.formData
                        }
                        if(!!this.formData.id){
                            
                        }else{
                            systemFilegroupAdd(param).then(res=>{
                                this.loadingSave=false
                                if(res.code ==2000) {
                                    this.$message.success(res.msg)
                                    this.handleClose()
									this.getMenu()
                                } else {
                                    this.$message.warning(res.msg)
                                }
                            })
                        }

                    }
                })
			},
			// 使用自定义处理函数来确保正确构建树形结构
			customToTree(data){
				const treeData = XEUtils.toArrayTree(data, {
					parentKey: 'parent',
					strict: false // 允许 parent 为 null
				});
				return treeData;
			},
			//获取分组数据
			getMenu(){
				this.menuLoading = true
                systemFilegroup({page:1,limit:999}).then(res=>{
                    if(res.code === 2000){
						this.menu = this.customToTree(res.data.data)
                    }
                    this.menuLoading = false
                })
				
			},
			//获取列表数据
			getData(){
				this.listLoading = true
				var reqData = {
					group: this.menuId,
					page: this.currentPage,
					limit: this.pageSize,
					search: this.keyword
				}
				if(this.onlyImage){
					reqData.type = 'image'
				}
                systemFiles(reqData).then(res=>{
                    if(res.code === 2000){
                        this.data = res.data.data
                        this.total = res.data.total
                        this.$refs.scrollbar.setScrollTop(0)
                    }
                    this.listLoading = false
                })
				
			},
			//树点击事件
			groupClick(data){
				this.menuId = data.id
				this.currentPage = 1
				this.keyword = null
				this.getData()
			},
			//分页刷新表格
			reload(){
				this.getData()
			},
			search(){
				this.currentPage = 1
				this.getData()
			},
			select(item){
				const itemUrl = item[this.fileProps.url]
				if(this.multiple){
					if(this.value.includes(itemUrl)){
						this.value.splice(this.value.findIndex(f => f == itemUrl), 1)
					}else{
						this.value.push(itemUrl)
					}
				}else{
					if(this.value.includes(itemUrl)){
						this.value = ''
					}else{
						this.value = itemUrl
					}
				}
			},
			submit(){
				const value = JSON.parse(JSON.stringify(this.value))
				this.$emit('update:modelValue', value);
				this.$emit('submit', value);
			},
			//上传处理
			uploadChange(file, fileList){
				file.tempImg = URL.createObjectURL(file.raw);
				this.fileList = fileList
			},
			uploadBefore(file){
				const maxSize = file.size / 1024 / 1024 < this.maxSize;
				if (!maxSize) {
					this.$message.warning(`上传文件大小不能超过 ${this.maxSize}MB!`);
					return false;
				}
			},
			uploadRequest(param){
				var apiObj = systemFilesAdd;
				const data = new FormData();
				data.append("file", param.file);
				data.append("group", this.menuId);
				apiObj(data, {
					onUploadProgress: e => {
						param.onProgress(e)
					}
				}).then(res => {
					if(res.code === 2000){
						param.onSuccess(res)
					}else{
						param.onError(res.msg)
					}
				}).catch(err => {
					param.onError(err)
				})
			},
			uploadProcess(event, file){
				file.progress = Number((event.loaded / event.total * 100).toFixed(2))
			},
			uploadSuccess(res, file){
				this.fileList.splice(this.fileList.findIndex(f => f.uid == file.uid), 1)
				var response = {
					id: res.data.id,
					name: res.data.name,
					url: res.data.url
				}
				this.data.unshift({
					[this.fileProps.key]: response.id,
					[this.fileProps.fileName]: response.name,
					[this.fileProps.url]: response.url
				})
				if(!this.multiple){
					this.value = response.url
				}
			},
			uploadError(err){
				this.$notify.error({
					title: '上传文件错误',
					message: err
				})
			},
			//内置函数
			_isImg(fileUrl){
				const imgExt = ['.jpg', '.jpeg', '.png', '.gif', '.bmp']
				const fileExt = fileUrl.substring(fileUrl.lastIndexOf("."))
				return imgExt.indexOf(fileExt) != -1
			},
			_getExt(fileUrl){
				return fileUrl.substring(fileUrl.lastIndexOf(".") + 1)
			}
		}
	}
</script>

<style scoped>
	.menu:deep(.el-tree-node__content){
		height: 36px;
	}
    .el-tree.menu .el-tree-node__content .el-tree-node__label .icon {
		margin-right: 5px;
	}
	.ly-file-select {
        display: flex;
    }
	.ly-file-select__files {
        flex: 1;
    }

	.ly-file-select__list {
        height:500px;
    }
	.ly-file-select__item {
        display: inline-block;
        float: left;
        margin:0 15px 25px 0;
        width:110px;
        cursor: pointer;
    }
	.ly-file-select__item__file {
        width:110px;
        height:110px;
        position: relative;
    }
	.ly-file-select__item__file .el-image {
        width:110px;
        height:110px;
    }
	.ly-file-select__item__box {
        position: absolute;
        top:0;
        right:0;
        bottom:0;
        left:0;
        border: 2px solid var(--el-color-success);
        z-index: 1;
        display: none;
    }
	.ly-file-select__item__box::before {
        content: '';
        position: absolute;
        top:0;
        right:0;
        bottom:0;
        left:0;
        background: var(--el-color-success);
        opacity: 0.2;
        display: none;
    }
	.ly-file-select__item:hover .ly-file-select__item__box {
        display: block;
    }
	.ly-file-select__item.active .ly-file-select__item__box {
        display: block;
    }
	.ly-file-select__item.active .ly-file-select__item__box::before {
        display: block;
    }
	.ly-file-select__item p {
        margin-top: 10px;
        white-space:nowrap;
        text-overflow:ellipsis;
        overflow:hidden;
        -webkit-text-overflow:ellipsis;
        text-align: center;
		height: 20px;
    }
	.ly-file-select__item__checkbox {
        position: absolute;
        width: 20px;
        height: 20px;
        top:7px;
        right:7px;
        z-index: 2;
        background: rgba(0,0,0,0.2);
        border: 1px solid #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
	.ly-file-select__item__checkbox i {
        font-size: 14px;
        color: #fff;
        font-weight: bold;
        display: none;
    }
	.ly-file-select__item__select {
        position: absolute;
        width: 20px;
        height: 20px;
        top:0px;
        right:0px;
        z-index: 2;
        background: var(--el-color-success);
        display: none;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
	.ly-file-select__item__select i {
        font-size: 14px;
        color: #fff;
        font-weight: bold;
    }
	.ly-file-select__item.active .ly-file-select__item__checkbox {
        background: var(--el-color-success);
    }
	.ly-file-select__item.active .ly-file-select__item__checkbox i {
        display: block;
    }
	.ly-file-select__item.active .ly-file-select__item__select {
        display: flex;
    }
	.ly-file-select__item__file .item-file {
        width:110px;
        height:110px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
	.ly-file-select__item__file .item-file i {
        font-size: 40px;
    }
	.ly-file-select__item__file .item-file.item-file-doc {
        color: #409eff;
    }

	.ly-file-select__item__upload {
		position: absolute;
		top:0;
		right:0;
		bottom:0;
		left:0;
		z-index: 1;
		background: rgba(255,255,255,0.7);
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.ly-file-select__side {
        width: 200px;
        margin-right: 15px;
        border-right: 1px solid rgba(128,128,128,0.2);
        display: flex;
        flex-flow: column;
    }
	.ly-file-select__side-menu {
        flex: 1;
    }
	.ly-file-select__side-msg {
        height:32px;
        line-height: 32px;
    }

	.ly-file-select__top {
        margin-bottom: 15px;
        display: flex;
        justify-content: space-between;
    }
	.ly-file-select__upload {
        display: inline-block;
    }
	.ly-file-select__top .tips {
        font-size: 12px;
        margin-left: 10px;
        color: #999;
    }
	.ly-file-select__top .tips i {
        font-size: 14px;
        margin-right: 5px;
        position: relative;
        bottom: -0.125em;
    }
	.ly-file-select__pagination {
        margin:15px 0;
    }

	.ly-file-select__do {
        text-align: right;
    }
</style>
